import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InfoCircleLightIcon(props) {
  return <FontAwesomeIcon icon={faInfoCircle} {...props} />;
}
